import {
  RECEIVE_FEED_OWNER_DETAIL_USERS,
  RECEIVE_FEED_OWNER_DETAIL_ROWS,
  FeedOwnerDetailRow
} from "../actions/feedOwnerReportDetail";

interface State {
  users: string[];
  rows: FeedOwnerDetailRow[];
  selectedUser: string | null;
}

const DEFAULT_STATE: State = { users: [], rows: [], selectedUser: null };

const feedOwnerReportDetail = (state: State = DEFAULT_STATE, action: any): State => {
  switch (action.type) {
    case RECEIVE_FEED_OWNER_DETAIL_USERS:
      return { ...state, users: action.users };
    case RECEIVE_FEED_OWNER_DETAIL_ROWS:
      return { ...state, rows: action.rows, selectedUser: action.user };
    default:
      return state;
  }
};

export default feedOwnerReportDetail;
